import tinycolor from 'tinycolor2';

module.exports = Backbone.Model.extend({
  url: function () {
    return this.baseUrl + (this.id ? 'colors/' + this.id : 'colors');
  },

  parse: function (resource) {
    var b = parseInt(resource['data']['color_code'] / 65536);
    var g = parseInt((resource['data']['color_code'] - b * 65536) / 256);
    var r = parseInt(resource['data']['color_code'] - b * 65536 - g * 256);
    var color = tinycolor('rgb(' + r + ',' + g + ',' + b + ')');

    resource['data']['color_code'] = color.toHexString();
    resource['data']['is_dark'] = color.isDark();
    if (this && this.attributes && this.attributes.data) resource['data']['palette'] = this.attributes.data.palette;

    return resource;
  },

  getServerModel: function () {
    var result = _(this.attributes).clone();
    var rgb = tinycolor(result['data']['color_code']).toRgb();

    result['data'] = _(result['data']).omit('is_dark');
    result['data']['color_code'] = rgb.b * 65536 + rgb.g * 256 + rgb.r;

    return result;
  },

  sync: function () {
    this.toJSON = this.getServerModel;
    var result = Backbone.sync.apply(this, arguments);
    this.toJSON = Backbone.Model.prototype.toJSON;

    return result;
  }
});
